// import "./Settings.css";
// import Header from "../header/Header";
// import Footer from "../Footer/Footer";
// import { useEffect, useState } from 'react';
// import Appconfig from '../../config/config'
// import { useNavigate } from 'react-router-dom';
// import { NotificationManager } from 'react-notifications';
// import axios from 'axios';
// import { useDispatch, useSelector } from 'react-redux';
// import Helper from "../../helper";
// import ExposureHeader from '../ExposureHeader/ExposureHeader';
// import ScrollGames from "../ScrollGames/ScrollGames";
// import OpenBets from "../OpenBets/OpenBets";
// import RightSection from "../RightSection/RightSection";


// function Settings() {
//   const userInfo = Helper(); // get login user details

//   const navigate = useNavigate();
//   const [chipList, setchipList] = useState([]);
//   const [eventType, setEventType] = useState(undefined);

//   useEffect(() => {
//     getChips();
//   }, [])

//   const getChips = async () => {
//     var data = JSON.stringify({
//       "user_id": userInfo._id
//     });
//     var config = {
//       method: 'post',
//       url: `${Appconfig.apiUrl}chips/getChips`,
//       headers: {
//         'Content-Type': 'application/json'
//       },
//       data: data
//     };
//     axios(config)
//       .then(function (response) {
//         try {
//           setchipList(response.data);
//           // let tmpChipList = response.data;
//           // const newChipList = tmpChipList.map((chipList, index) => {
//           //     tmpChipList[index]["id"] = index + 1;
//           // });
//           // setchipList(tmpChipList);
//         } catch (e) {
//           // postErrorToslack(e.message);
//         }
//       })
//       .catch(function (error) {
//         // postErrorToslack(error.message);
//         console.log(error);
//       });
//   }


//   const handleInputChange = (event) => {
//     let index = event.target.getAttribute('data-id');
//     console.clear();
//     console.log('index', index)
//     // const newChipList = chipList.map((chip, index) => {
//     //     if(index == tempIndex)
//     //     {
//     //         console.log('chipList1',chip);
//     //         chipList[index]["chip_value"] =  parseFloat(event.target.value)
//     //     }
//     // });
//     console.log('before', chipList[index])
//     chipList[index]["chip_value"] = parseFloat(event.target.value == '' ? 0 : event.target.value);
//     console.log('after', chipList[index])
//     setchipList([
//       ...chipList,
//     ]);
//     console.log('chipList', chipList);
//   }

//   function updateChips(chipList) {
//     let newdata = [];
//     for (var i = 0; i < chipList.length; i++) {
//       newdata[i] = { "_id": chipList[i]._id, "chip_value": document.getElementById('stakeEdit_8' + chipList[i]._id).value };
//     }
//     var data = JSON.stringify({
//       "data": newdata
//     });
//     var config = {
//       method: 'post',
//       url: `${Appconfig.apiUrl}chips/updateMultipleChips`,
//       headers: {
//         'Content-Type': 'application/json'
//       },
//       data: data
//     };
//     axios(config)
//       .then(function (response) {
//         try {
//           if (response.data.ok) {
//             NotificationManager.success('Stake Update Successfully!', '', 3000);
//             getChips();
//             setTimeout(() => {
//               navigate('/');
//             }, 2000)

//           }
//         } catch (e) {
//           // postErrorToslack(e.message);
//         }
//       })
//       .catch(function (error) {
//         // postErrorToslack(error.message);
//         console.log(error);
//       });
//   }


//   return (
//     <>
//       {/* <Header /> */}
//       {/* <ExposureHeader/> */}
//       {/* <ScrollGames eventType={eventType} setEventType={setEventType} /> */}


//       <div className="setting lg:pl-[18rem]">
//         <div className="settings-container">
//           <span>Settings</span>
//         </div>
//         <p className="odds">
//           <span>Edit Stakes</span>
//         </p>
//         <div className="edit-stakes">
//           {chipList.map((row, index) => (
//             <label key={index}>
//               <input
//                 id={`stakeEdit_8${row._id}`}
//                 type='text'
//                 pattern="[0-9]*"
//                 data-id={index}
//                 value={row.chip_value}
//                 onChange={handleInputChange}
//               />
//             </label>
//           ))}
//         </div>

//         {/* Edit button */}
//         {
//           chipList.length > 0 &&
//           <div className="edit-button ">
//             <button onClick={() => updateChips(chipList)} className="edit-btn bg-gradient-to-b from-[#5ecbdd] to-[#146578] border border-[#72bbef]">
//               Save
//             </button>
//           </div>
//         }
//       </div>




//     </>
//   );
// }

// export default Settings;


import "./Settings.css";
// import Header from "../header/Header";
// import Footer from "../Footer/Footer";
import { useEffect, useState } from 'react';
import Appconfig from '../../config/config';
import { useNavigate } from 'react-router-dom';
import { NotificationManager } from 'react-notifications';
import axios from 'axios';
import Helper from "../../helper";
// import ExposureHeader from '../ExposureHeader/ExposureHeader';
// import ScrollGames from "../ScrollGames/ScrollGames";
// import OpenBets from "../OpenBets/OpenBets";
// import RightSection from "../RightSection/RightSection";

function Settings() {
  const userInfo = Helper(); // get login user details
  const navigate = useNavigate();
  const [chipList, setChipList] = useState([]);
  // const [eventType, setEventType] = useState(undefined); // Unused state

  useEffect(() => {
    getChips();
  }, []);

  // const getChips = async () => {
  //   try {
  //     const response = await axios.post(`${Appconfig.apiUrl}chips/getChips`, {
  //       "user_id": userInfo._id
  //     }, {
  //       headers: { 'Content-Type': 'application/json' }
  //     });
  //     setChipList(response.data);
  //   } catch (error) {
  //     console.error("Failed to fetch chips:", error);
  //     // Optionally show an error notification to the user
  //     // NotificationManager.error('Could not load stakes.', 'Error', 3000);
  //   }
  // };
  const getChips = async () => {
    try {
      const response = await axios.post(`${Appconfig.apiUrl}chips/getChips`, {
        "user_id": userInfo._id
      }, {
        headers: { 'Content-Type': 'application/json' }
      });

      const chipsData = response.data;

      // --- SOLUTION ---
      // Check if the received data is an array. If not, use an empty array.
      if (Array.isArray(chipsData)) {
        setChipList(chipsData);
      } else {
        console.error("API did not return an array for chips. Response:", chipsData);
        setChipList([]); // Fallback to an empty array to prevent crash
      }

    } catch (error) {
      console.error("Failed to fetch chips:", error);
      // Also set to empty array on error to be safe
      setChipList([]);
    }
  }

  const handleInputChange = (event) => {
    const indexToUpdate = parseInt(event.target.getAttribute('data-id'), 10);
    // Ensure the value is a number, default to 0 if empty or invalid
    const newValue = parseFloat(event.target.value) || 0;

    // Correctly update state immutably
    const newChipList = chipList.map((chip, index) => {
      if (index === indexToUpdate) {
        return { ...chip, chip_value: newValue }; // Create a new object
      }
      return chip;
    });
    setChipList(newChipList);
  };

  const updateChips = async (currentChipList) => {
    // CORRECT: Use the state data, not the DOM
    const payloadData = currentChipList.map(chip => ({
      _id: chip._id,
      chip_value: chip.chip_value
    }));

    try {
      const response = await axios.post(`${Appconfig.apiUrl}chips/updateMultipleChips`, {
        "data": payloadData
      }, {
        headers: { 'Content-Type': 'application/json' }
      });

      if (response.data.ok) {
        NotificationManager.success('Stake Update Successfully!', '', 3000);
        // No need to call getChips() again, local state is already correct
        setTimeout(() => {
          navigate('/');
        }, 2000);
      }
    } catch (error) {
      console.error("Failed to update chips:", error);
      NotificationManager.error('Failed to update stakes.', 'Error', 3000);
    }
  };

  return (
    <>
      <div className="setting lg:pl-[18rem]">
        <div className="settings-container">
          <span>Settings</span>
        </div>
        <p className="odds">
          <span>Edit Stakes</span>
        </p>
        <div className="edit-stakes">
          {chipList.map((row, index) => (
            <label key={row._id}> {/* FIX: Use stable _id for key */}
              <input
                id={`stakeEdit_8${row._id}`}
                type='text' // For numbers, type='number' might be better
                pattern="[0-9]*"
                data-id={index}
                value={row.chip_value}
                onChange={handleInputChange}
              />
            </label>
          ))}
        </div>

        {chipList.length > 0 &&
          <div className="edit-button ">
            <button onClick={() => updateChips(chipList)} className="edit-btn bg-gradient-to-b from-[#5ecbdd] to-[#146578] border border-[#72bbef]">
              Save
            </button>
          </div>
        }
      </div>
    </>
  );
}

export default Settings;